import { render, staticRenderFns } from "./ProfileAccounts.vue?vue&type=template&id=1011ea9b&scoped=true&"
import script from "./ProfileAccounts.vue?vue&type=script&lang=ts&"
export * from "./ProfileAccounts.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileAccounts.vue?vue&type=style&index=0&id=1011ea9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1011ea9b",
  null
  
)

export default component.exports